<template>
  <div class="flex-col">
    <div class="flex-col group_18">
      <div class="tab-list flex-row justify-between items-center group_19">
        <template v-for="(item, index) in tabs">
          <span class="tab-item" v-if="item.status === MODULE_STATUS.NORMAL" @click="handleClick(item, index)" :class="{ active: item.selected }" :key="item.id">{{ item.tabName }}</span>
        </template>
      </div>
    </div>
    <div class="flex-row relative group_20" v-if="currentType === TAB_TYPE.RECOMMEND">
      <div class="flex-col section_12 space-y-44 pos_9">
        <div class="flex-col justify-start items-center self-start text-wrapper_6">
          <span class="font_6 text_29">预告</span>
        </div>
        <img class="self-center image_19" src="https://ysh-cdn.kaidicloud.com/codefun/preview/1a971b188519a40a8535fb326f91c9e8.png" />
      </div>
      <div class="flex-col section_14 space-y-58 pos_11">
        <img class="shrink-0 self-center image_20" src="https://ysh-cdn.kaidicloud.com/codefun/preview/db2ef938d1005eb021ded80f92a512b3.png" />
        <div class="flex-col section_15 space-y-8">
          <span class="font_14 text_30">点燃梦想 相信香信的力量 新的动力新的…</span>
          <div class="flex-row items-center space-x-4">
            <img class="image_22" src="https://ysh-cdn.kaidicloud.com/codefun/preview/d3c0c1cb6898387dbd42acaed86a0025.png" />
            <span class="font_8">老板说</span>
          </div>
        </div>
      </div>
      <div class="flex-col justify-start items-start section_13 pos_10">
        <div class="flex-row items-center section_7 view_2">
          <img class="shrink-0 image_15" src="https://ysh-cdn.kaidicloud.com/codefun/preview/cdf2367b23760bb137a541bcf5433dad.png" />
          <span class="font_6">直播中</span>
        </div>
      </div>
      <img class="image_23 pos_13" src="https://ysh-cdn.kaidicloud.com/codefun/preview/48caaf7eaf788f0a454311251f37c9e4.png" />
      <div class="flex-col section_16 space-y-6 pos_14">
        <span class="font_14 text_31">点燃的梦想 相信力量</span>
        <div class="flex-row items-center space-x-4">
          <img class="image_22" src="https://ysh-cdn.kaidicloud.com/codefun/preview/f1a9dc01301d7eff4ecca1fcc2883792.png" />
          <span class="font_7">赢商学院</span>
        </div>
      </div>
      <img class="image_21 pos_12" src="https://ysh-cdn.kaidicloud.com/codefun/preview/01a4746402f2b35a27031cdd908affc8.png" />
      <img class="image_24 pos_16" src="https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png" />
      <div class="flex-col section_16 space-y-6 pos_17">
        <span class="font_14 text_31">点燃的梦想 相信力量</span>
        <div class="flex-row items-center space-x-4">
          <img class="image_22" src="https://ysh-cdn.kaidicloud.com/codefun/preview/f1a9dc01301d7eff4ecca1fcc2883792.png" />
          <span class="font_7">赢商学院</span>
        </div>
      </div>
      <img class="image_21 pos_15" src="https://ysh-cdn.kaidicloud.com/codefun/preview/3dd69469799b4908a1572fa7926a3107.png" />
      <div class="section_17 pos_20"></div>
      <span class="font_3 text_32 pos_19">没有更多了</span>
      <div class="section_18 pos_21"></div>
    </div>
    <div v-else-if="currentType === TAB_TYPE.DYNAMIC">
      <div class="flex-col section_5">
        <div class="flex-row space-x-8">
          <img class="shrink-0 image_7" src="https://ysh-cdn.kaidicloud.com/codefun/preview/e760c1e9dd87d3ae539436ba3d69886f.png" />
          <div class="flex-col flex-auto">
            <span class="font_2 text_6">唐小天唐小天唐小天唐小天</span>
            <div class="flex-row space-x-8">
              <span class="font_3 text_8">总监 |</span>
              <span class="font_3 text_9">广东红海有限公司</span>
            </div>
          </div>
          <img class="shrink-0 self-start image_8" src="https://ysh-cdn.kaidicloud.com/codefun/preview/769e622aab93beccdc8abe151eb42686.png" />
          <div class="flex-row items-center shrink-0 self-center section_6 space-x-3">
            <img class="shrink-0 image_9" src="https://ysh-cdn.kaidicloud.com/codefun/preview/e844bc1eea685fbf02f2864435786d67.png" />
            <span class="font_3 text_7">关注</span>
          </div>
        </div>
        <div class="flex-col group_3 space-y-16">
          <div class="flex-col justify-start relative">
            <span class="font_4 text_10"> 中国美国商会：在华美企视中国为首选投资中国美中国美国商会：在华美企视中国为首选投资中国美在华美企视中国为首选投资中中啊中啊国美… </span>
            <span class="font_4 text_11 pos">全文</span>
          </div>
          <img class="self-start image_10" src="https://ysh-cdn.kaidicloud.com/codefun/preview/2c536e845cf68049495a047b2e01612f.png" />
        </div>
        <div class="flex-row group_3">
          <img class="image_11" src="https://ysh-cdn.kaidicloud.com/codefun/preview/4365a7adf9efa573877f77efe1d4537c.png" />
          <span class="font_3 text_12">广州市 · 珠江新城·地址一行</span>
        </div>
        <div class="flex-row justify-between group_3 view">
          <div class="flex-row space-x-8">
            <span class="font_5">#会员分享</span>
            <span class="font_5">#视频动态</span>
          </div>
          <span class="font_3 text_13">8小时前</span>
        </div>
        <div class="flex-row justify-between equal-division group_4">
          <div class="flex-row space-x-4">
            <img class="shrink-0 image_12" src="https://ysh-cdn.kaidicloud.com/codefun/preview/655863c76554270dcfcdb7eff7ccf9e3.png" />
            <span class="font_6">分享</span>
          </div>
          <div class="flex-row space-x-4">
            <img class="shrink-0 image_12" src="https://ysh-cdn.kaidicloud.com/codefun/preview/1fbc414780a6b53d368e4f5a1806f1f5.png" />
            <span class="font_6">评论</span>
          </div>
          <div class="flex-row space-x-4">
            <img class="shrink-0 image_12" src="https://ysh-cdn.kaidicloud.com/codefun/preview/3849e604e8d2d44b0523d50a57e5b9be.png" />
            <span class="font_6">点赞</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="currentType === TAB_TYPE.BOSS">
      <div class="boss-list">
        <div class="boss-item">
          <img class="video-icon" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ffb53938df3602eab760646750c6c470.png" />
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ww538d02eab760646750c6c470.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
          </div>
        </div>
        <div class="boss-item">
          <img class="video-icon" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ffb53938df3602eab760646750c6c470.png" />
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ww538d02eab760646750c6c470.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
          </div>
        </div>
        <div class="boss-item">
          <img class="video-icon" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ffb53938df3602eab760646750c6c470.png" />
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ww538d02eab760646750c6c470.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
          </div>
        </div>
        <div class="boss-item">
          <img class="video-icon" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ffb53938df3602eab760646750c6c470.png" />
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/ww538d02eab760646750c6c470.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="boss-list">
        <div class="boss-item">
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
            <div style="margin-top: 10px" class="flex-row justify-between">
              <span class="font_3">张佳羽</span>
              <span class="font_3">10分钟前</span>
            </div>
          </div>
        </div>
        <div class="boss-item">
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
            <div style="margin-top: 10px" class="flex-row justify-between">
              <span class="font_3">张佳羽</span>
              <span class="font_3">10分钟前</span>
            </div>
          </div>
        </div>
        <div class="boss-item">
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
            <div style="margin-top: 10px" class="flex-row justify-between">
              <span class="font_3">张佳羽</span>
              <span class="font_3">10分钟前</span>
            </div>
          </div>
        </div>
        <div class="boss-item">
          <img class="boss-item-img" style="height: 150px" src="https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png" />
          <div class="flex-col section_8 space-y-8">
            <span class="font_7 text_10">点燃梦想 相信香信的力量 新的动力新的…</span>
            <div style="margin-top: 10px" class="flex-row justify-between">
              <span class="font_3">张佳羽</span>
              <span class="font_3">10分钟前</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { MODULE_STATUS, TAB_TYPE } from './constant'
export default {
  props: {
    content: {
      required: true,
      type: Array,
    },
  },
  data() {
    return {
      MODULE_STATUS,
      tabs: this.$props.content,
      /** 当前类型 */
      currentType: TAB_TYPE.RECOMMEND,
      TAB_TYPE,
    }
  },
  created() {
    this.tabs = this.$props.content.map((item) => {
      if (item.selected) {
        this.currentType = item.tarType
      }
      return item
    })
  },
  methods: {
    handleClick(data, index) {
      this.tabs.forEach((item) => {
        item.selected = item.id === data.id
      })
      this.currentType = data.tarType
    },
  },
}
</script>

<style lang="less" scoped>
.group_18 {
  padding: 0 12px 24px 24px;
  .group_19 {
    padding: 24px 0 6px;
    .font_4 {
      font-size: 34px;
      font-family: 'PingFang SC';
      line-height: 48px;
      font-weight: 500;
      color: #222222;
    }
    .text_24 {
      color: #f93809;
      font-size: 36px;
      line-height: 50px;
    }
    .font_13 {
      font-size: 30px;
      font-family: 'PingFang SC';
      line-height: 40px;
      color: #222222;
    }
    .text_25 {
      line-height: 42px;
    }
    .text_26 {
      line-height: 42px;
    }
    .text_27 {
      line-height: 42px;
    }
    .text_28 {
      line-height: 42px;
    }
  }
  .section_11 {
    margin-left: 16px;
    background-color: #f93809;
    border-radius: 3px;
    width: 40px;
    height: 6px;
  }
}
.section_5 {
  padding: 32px 30px 116px;
  background-color: #ffffff;
  .space-x-8 {
    & > *:not(:first-child) {
      margin-left: 16px;
    }
    .image_7 {
      border-radius: 8px;
      width: 80px;
      height: 80px;
    }
    .font_2 {
      font-size: 34px;
      font-family: 'PingFang SC';
      line-height: 48px;
      color: #333333;
    }
    .text_6 {
      font-size: 32px;
      line-height: 44px;
    }
    .text_8 {
      font-size: 24px;
      line-height: 34px;
    }
    .text_9 {
      font-size: 24px;
      line-height: 34px;
    }
    .image_8 {
      margin-top: 6px;
      width: 32px;
      height: 32px;
    }
    .section_6 {
      margin-right: 4px;
      padding: 8px 28px;
      border-radius: 8px;
      height: 56px;
      border: solid 1px #f93809;
      .image_9 {
        width: 26px;
        height: 26px;
      }
      .text_7 {
        color: #f93809;
      }
    }
    .space-x-3 {
      & > *:not(:first-child) {
        margin-left: 6px;
      }
    }
    .font_5 {
      font-size: 26px;
      font-family: 'PingFang SC';
      line-height: 36px;
      color: #6c353d;
    }
  }
  .group_3 {
    margin-top: 32px;
    padding: 0 2px;
    .font_4 {
      font-size: 30px;
      font-family: 'PingFang SC';
      line-height: 42px;
    }
    .text_10 {
      margin-right: 24px;
      color: #222222;
      text-align: justify;
    }
    .text_11 {
      color: #f93809;
    }
    .pos {
      position: absolute;
      right: 0;
      bottom: 0;
    }
    .image_10 {
      border-radius: 16px;
      width: 440px;
      height: 742px;
    }
    .image_11 {
      width: 36px;
      height: 36px;
    }
    .text_12 {
      color: #4c5e78;
    }
    .text_13 {
      font-size: 24px;
      line-height: 34px;
    }
  }
  .space-y-16 {
    & > *:not(:first-child) {
      margin-top: 32px;
    }
  }
  .font_3 {
    font-size: 26px;
    font-family: 'PingFang SC';
    line-height: 36px;
    color: #999999;
  }
  .view {
    margin-top: 16px;
  }
  .equal-division {
    align-self: center;
    margin-top: 24px;
    .space-x-4 {
      & > *:not(:first-child) {
        margin-left: 8px;
      }
      .image_12 {
        width: 40px;
        height: 40px;
      }
      .font_6 {
        font-size: 26px;
        font-family: 'PingFang SC';
        line-height: 36px;
        color: #666666;
      }
    }
  }
  .group_4 {
    width: 559px;
  }
}
.tab-list {
  display: flex;
  overflow-x: auto;
}
.tab-item {
  font-size: 30px;
  color: #222222;
  line-height: 42px;
  padding: 0 24px;

  &.active {
    position: relative;
    font-size: 36px;
    font-weight: bolder;
    color: #f93809;
    line-height: 50px;

    &::after {
      content: '';
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -6px;
      width: 40px;
      height: 6px;
      background: #f93809;
      border-radius: 4px;
    }
  }
}
.group_20 {
  padding: 0 24px 72px;
  height: 1823px;
  .section_12 {
    padding: 16px;
    border-radius: 12px;
    background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/45b40785e090fa4ed59f35c2f2e1e1b1.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 338px;
    .text-wrapper_6 {
      background-image: linear-gradient(299.7deg, #ff7615 0%, #ff7615 -20.06%, #ffa21f 120.06%, #ffa21f 100%);
      border-radius: 4px;
      width: 56px;
      .text_29 {
        font-weight: 500;
      }
    }
    .image_19 {
      width: 48px;
      height: 6px;
    }
  }
  .space-y-44 {
    & > *:not(:first-child) {
      margin-top: 88px;
    }
  }
  .pos_9 {
    position: absolute;
    left: 24px;
    top: 0;
  }
  .section_14 {
    padding-top: 112px;
    overflow: hidden;
    border-radius: 12px;
    background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/0e7c9056f50ebac9dba82118cfd66c5d.png');
    background-position: 0% 0%;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 338px;
    .image_20 {
      width: 92px;
      height: 94px;
    }
    .section_15 {
      padding: 40px 18px 18px;
      background-image: linear-gradient(180deg, #00000000 0%, #000000e6 74.67%, #000000e6 100%);
      border-radius: 0px 0px 12px 12px;
      .text_30 {
        color: #ffffff;
        line-height: 42px;
        text-align: left;
      }
    }
    .space-y-8 {
      & > *:not(:first-child) {
        margin-top: 16px;
      }
    }
  }
  .space-y-58 {
    & > *:not(:first-child) {
      margin-top: 116px;
    }
  }
  .pos_11 {
    position: absolute;
    left: 24px;
    top: 184px;
  }
  .section_13 {
    padding: 16px 0 472px;
    border-radius: 12px;
    background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/ab26022fd92b701ae5fc5c239b88af36.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    width: 338px;
    .section_7 {
      padding: 2px 8px;
      background-image: linear-gradient(108.4deg, #fb6d3d 0%, #fb6d3d -20.71%, #f23f4e 120.71%, #f23f4e 100%);
      border-radius: 6px;
      .image_15 {
        width: 16px;
        height: 16px;
      }
    }
    .view_2 {
      margin-left: 16px;
    }
  }
  .pos_10 {
    position: absolute;
    right: 24px;
    top: 0;
  }
  .font_6 {
    font-size: 20px;
    font-family: 'PingFang SC';
    line-height: 28px;
    color: #ffffff;
  }
  .image_23 {
    border-radius: 12px 12px 0 0;
    width: 338px;
    height: 280px;
  }
  .pos_13 {
    position: absolute;
    left: 24px;
    top: 728px;
  }
  .section_16 {
    padding: 20px 18px;
    background-color: #ffffff;
    border-radius: 0px 0px 12px 12px;
    width: 338px;
    .text_31 {
      line-height: 42px;
    }
  }
  .space-y-6 {
    & > *:not(:first-child) {
      margin-top: 12px;
    }
  }
  .pos_14 {
    position: absolute;
    left: 24px;
    top: 1008px;
  }
  .font_14 {
    font-size: 30px;
    font-family: 'PingFang SC';
    line-height: 40px;
    font-weight: 500;
    color: #222222;
  }
  .space-x-4 {
    & > *:not(:first-child) {
      margin-left: 8px;
    }
    .image_22 {
      border-radius: 50%;
      width: 40px;
      height: 40px;
    }
    .font_8 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #ffffff;
    }
    .font_7 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #666666;
    }
  }
  .image_21 {
    border-radius: 12px;
    width: 338px;
    height: 520px;
  }
  .pos_12 {
    position: absolute;
    right: 24px;
    top: 544px;
  }
  .image_24 {
    border-radius: 12px 12px 0 0;
    width: 338px;
    height: 374px;
  }
  .pos_16 {
    position: absolute;
    left: 24px;
    bottom: 283px;
  }
  .pos_17 {
    position: absolute;
    left: 24px;
    top: 1540px;
  }
  .pos_15 {
    position: absolute;
    right: 30px;
    bottom: 215px;
  }
  .section_17 {
    background-image: linear-gradient(268.6deg, #e8e8e800 0%, #e8e8e800 5.28%, #cccccc 117.08%, #cccccc 100%);
    width: 40px;
    height: 2px;
  }
  .pos_20 {
    position: absolute;
    left: 241px;
    top: 1730px;
  }
  .font_3 {
    font-size: 24px;
    font-family: 'PingFang SC';
    line-height: 34px;
    color: #222222;
  }
  .text_32 {
    color: #cccccc;
    font-size: 26px;
    line-height: 36px;
  }
  .pos_19 {
    position: absolute;
    left: 50%;
    bottom: 73px;
    transform: translateX(-50%);
  }
  .section_18 {
    background-image: linear-gradient(91.4deg, #e8e8e800 0%, #e8e8e800 5.28%, #cccccc 117.08%, #cccccc 100%);
    width: 40px;
    height: 2px;
  }
  .pos_21 {
    position: absolute;
    right: 241px;
    top: 1730px;
  }
  .image_25 {
    overflow: hidden;
    width: 120px;
    height: 126px;
  }
  .pos_18 {
    position: absolute;
    right: 40px;
    bottom: 81px;
  }
}
.group_2 {
  padding: 0 32px;
  .group_12 {
    flex: 1 1 332px;
    .image_7 {
      border-radius: 12px 12px 0px 0px;
      width: 332px;
      height: 260px;
    }
    .image-wrapper_2 {
      margin-top: 24px;
      padding: 20px 0 202px;
      border-radius: 12px 12px 0px 0px;
      background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/554ea6218e1ce4999b60ff883dc67adc.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .image_9 {
        margin-right: 20px;
        width: 38px;
        height: 38px;
      }
    }
  }
  .group_13 {
    flex: 1 1 332px;
    .group_14 {
      padding: 360px 0 24px;
      .image_8 {
        border-radius: 12px 12px 0px 0px;
        width: 332px;
        height: 376px;
      }
      .pos_2 {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
      }
    }
    .section_9 {
      border-radius: 12px 12px 0px 0px;
      background-image: url('https://ysh-cdn.kaidicloud.com/codefun/preview/098de8e209d777c6dbf50df471040609.png');
      background-position: 0% 0%;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      height: 260px;
    }
    .section_10 {
      padding-left: 20px;
      padding-right: 8px;
      background-color: #ffffff;
      border-radius: 0px 0px 0 0;
      height: 104px;
      .image_10 {
        margin-top: -112px;
        filter: drop-shadow(0px 28px 24px #0000001a);
        width: 120px;
        height: 120px;
      }
      .text_11 {
        text-align: left;
        width: 280px;
      }
    }
    .space-y-6 {
      & > *:not(:first-child) {
        margin-top: 12px;
      }
    }
  }
  .section_8 {
    padding: 24px 20px;
    background-color: #ffffff;
    border-radius: 0px 0px 12px 12px;
    .text_8 {
      text-align: left;
    }
    .font_3 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #666666;
    }
    .text_10 {
      text-align: left;
    }
    .text_9 {
      text-align: left;
    }
  }
  .space-y-8 {
    & > *:not(:first-child) {
      margin-top: 16px;
    }
  }
  .font_7 {
    font-size: 30px;
    font-family: 'PingFang SC';
    line-height: 42px;
    color: #222222;
  }
}
.view_3 {
  margin-top: -20px;
}
.space-x-11 {
  & > *:not(:first-child) {
    margin-left: 22px;
  }
}
.group_21 {
  width: 338px;
  .image_24 {
    border-radius: 12px 12px 0 0;
    width: 338px;
    height: 374px;
  }
  .section_16 {
    padding: 20px 18px;
    background-color: #ffffff;
    border-radius: 0px 0px 12px 12px;
    .font_14 {
      font-size: 30px;
      font-family: 'PingFang SC';
      line-height: 40px;
      font-weight: 500;
      color: #222222;
    }
    .text_31 {
      line-height: 42px;
    }
    .space-x-4 {
      & > *:not(:first-child) {
        margin-left: 8px;
      }
      .image_22 {
        border-radius: 50%;
        width: 40px;
        height: 40px;
      }
      .font_7 {
        font-size: 24px;
        font-family: 'PingFang SC';
        line-height: 34px;
        color: #666666;
      }
    }
  }
  .space-y-6 {
    & > *:not(:first-child) {
      margin-top: 12px;
    }
  }
}

.boss-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 25px;
  padding-bottom: 20px;
  .boss-item {
    position: relative;
    width: 338px;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 25px;
  }
  .video-icon{
    display: block;
    width: 40px;
    height: 40px;
    position: absolute;
    right: 19px;
    top: 20px;

  }
  .section_8 {
    padding: 24px 20px;
    background-color: #ffffff;
    border-radius: 0px 0px 12px 12px;
    .font_7 {
      font-size: 30px;
      font-family: 'PingFang SC';
      line-height: 42px;
      color: #222222;
    }
    .text_10 {
      text-align: left;
    }
    .font_3 {
      font-size: 24px;
      font-family: 'PingFang SC';
      line-height: 34px;
      color: #666666;
    }
  }
  .boss-item-img {
    width: 338px;
    display: block;
    object-fit: cover;
  }
}
</style>
